import { Constants as ElectronicDocumentsConstants } from 'we-package-react-electronic-documents';
import { Constants as SecuredMessagingConstants } from 'we-package-react-secured-messaging';
import { Constants as DocumentCentreConstants } from 'we-package-react-document-centre';
import { Constants as PreferencesConstants } from 'we-package-react-preferences';
import { Constants as AccountContants } from 'we-package-react-account';
import { Constants as NewsConstants } from 'we-package-react-news';
import { Constants as PersonalInfoConstants } from 'we-package-react-personal-informations';

export default class Constants {
  public static ComposantsName = class {
    static ClientSpaceSnackBar = 'ClientSpaceSnackBar';
  };
  public static PagesUrl = class {
    static HomePage = '/';
    static Profile = '/profile';
    static LogOff = '/log-off';
    static SecureLogOff = '/secure/logoff';
    static AuthorizeCallback = '/authorize-callback';
    static Error = '/error';
    static Unauthorized = '/unauthorized';
    static TestPage = '/testpage';
    static ContactUs = '/contact-us';
    static Faq = '/faq';
    static GeneralTermsOfUse = '/general-terms-of-use';
    static PersonalInformationsProtection = '/personal-informations-protection';
    static SecurityInfoFormPage = '/update-security-information';
    static SecurityInfoConfirmationPage = `${this.SecurityInfoFormPage}/confirmation`;
    static UnavailablePage = '/unavailable';
    static TechnicalErrorPage = '/technical-error';
    static CentralizationErrorPage = '/centralization-error';
    static CentralizationBaseFragment = '/centralization';
    static CentralizationPage = `${this.CentralizationBaseFragment}/ia`;
    static CentralizationFormPage = `${this.CentralizationPage}/form`;
    static CentralizationConfirmationPage = `${this.CentralizationPage}/confirmation`;

    // iaah
    static AuthorizeCallbackIaah = '/authorize-callback-iaah';
    static CentralizationPageIaah = `${this.CentralizationBaseFragment}/iaah`;
    static CentralizationFormPageIaah = `${this.CentralizationPageIaah}/form`;
    static CentralizationConfirmationPageIaah = `${this.CentralizationPageIaah}/confirmation`;

    // iagp
    static AuthorizeCallbackIAGP = '/authorize-callback-iagp';
    static CentralizationPageIAGP = `${this.CentralizationBaseFragment}/iagp`;
    static CentralizationFormPageIAGP = `${this.CentralizationPageIAGP}/form`;
    static CentralizationConfirmationPageIAGP = `${this.CentralizationPageIAGP}/confirmation`;

    // iapw
    static AuthorizeCallbackIAPW = '/authorize-callback-iapw';
    static CentralizationPageIAPW = `${this.CentralizationBaseFragment}/iapw`;
    static CentralizationFormPageIAPW = `${this.CentralizationPageIAPW}/form`;
    static CentralizationConfirmationPageIAPW = `${this.CentralizationPageIAPW}/confirmation`;

    // investia
    static AuthorizeCallbackInvestia = '/authorize-callback-investia';
    static CentralizationPageInvestia = `${this.CentralizationBaseFragment}/investia`;
    static CentralizationFormPageInvestia = `${this.CentralizationPageInvestia}/form`;
    static CentralizationConfirmationPageInvestia = `${this.CentralizationPageInvestia}/confirmation`;
  };

  public static PublicRoutesWithAuthenticatedLayout = [
    Constants.PagesUrl.ContactUs,
    Constants.PagesUrl.Faq,
    Constants.PagesUrl.GeneralTermsOfUse,
    Constants.PagesUrl.PersonalInformationsProtection,
  ];

  public static AvailabilityCheckRoutes = [
    Constants.PagesUrl.HomePage,
    Constants.PagesUrl.LogOff,
    Constants.PagesUrl.SecurityInfoFormPage,
    Constants.PagesUrl.SecurityInfoConfirmationPage,
    Constants.PagesUrl.Error,
    Constants.PagesUrl.Unauthorized,
    Constants.PagesUrl.TestPage,
    `${Constants.PagesUrl.Profile}`,
    `${ElectronicDocumentsConstants.BasePagePath}`,
    `${SecuredMessagingConstants.BasePagePath}`,
    `${SecuredMessagingConstants.NewMessagePagePath}`,
    `${SecuredMessagingConstants.MessageDetailsPagePath}`,
    `${SecuredMessagingConstants.NewMessageConfirmationPagePath}`,
    `${DocumentCentreConstants.BasePagePath}`,
    `${PreferencesConstants.PreferencesCommunicationChangePath}`,
    `${PreferencesConstants.PreferencesCommunicationChangeConfirmationPath}`,
    `${AccountContants.UsernameFormPath}`,
    `${AccountContants.UsernameConfirmationPath}`,
    `${AccountContants.InvalidUsernameFormPath}`,
    `${AccountContants.InvalidUsernameConfirmationPath}`,
    `${AccountContants.SecurityQuestionsFormPath}`,
    `${AccountContants.SecurityQuestionsConfirmationPath}`,
    `${AccountContants.ChangePasswordFormPath}`,
    `${AccountContants.ChangePasswordConfirmationPath}`,
    `${AccountContants.MfaPasswordStepSegment}`,
    `${AccountContants.MfaInformationsStepSegment}`,
    `${AccountContants.MfaEmailStepSegment}`,
    `${AccountContants.MfaEmailCodeStepSegment}`,
    `${AccountContants.MfaPhoneStepSegment}`,
    `${AccountContants.MfaPhoneCodeStepSegment}`,
    `${AccountContants.MfaConfirmationStepSegment}`,
    `${NewsConstants.BasePagePath}`,
    `${NewsConstants.NewsDetailsPagePath}`,
    `${PersonalInfoConstants.ConsentConfirmationFormPagePath}`,
    `${PersonalInfoConstants.ConsentFormPagePath}`,
    `${PersonalInfoConstants.PersonalInformationsFormPagePath}`,
    `${PersonalInfoConstants.PersonalInformationsConfirmationPagePath}`,
    `${PersonalInfoConstants.PersonalInformationsIntroductionPagePath}`,
  ];
  public static ProtectedRoutes = [
    Constants.PagesUrl.HomePage,
    Constants.PagesUrl.SecurityInfoFormPage,
    Constants.PagesUrl.SecurityInfoConfirmationPage,
    Constants.PagesUrl.Error,
    Constants.PagesUrl.Unauthorized,
    Constants.PagesUrl.TestPage,
    `${Constants.PagesUrl.Profile}`,
    `${ElectronicDocumentsConstants.BasePagePath}`,
    `${SecuredMessagingConstants.BasePagePath}`,
    `${SecuredMessagingConstants.NewMessagePagePath}`,
    `${SecuredMessagingConstants.MessageDetailsPagePath}`,
    `${SecuredMessagingConstants.NewMessageConfirmationPagePath}`,
    `${DocumentCentreConstants.BasePagePath}`,
    `${PreferencesConstants.PreferencesCommunicationChangePath}`,
    `${PreferencesConstants.PreferencesCommunicationChangeConfirmationPath}`,
    `${AccountContants.UsernameFormPath}`,
    `${AccountContants.UsernameConfirmationPath}`,
    `${AccountContants.InvalidUsernameFormPath}`,
    `${AccountContants.InvalidUsernameConfirmationPath}`,
    `${AccountContants.SecurityQuestionsFormPath}`,
    `${AccountContants.SecurityQuestionsConfirmationPath}`,
    `${AccountContants.ChangePasswordFormPath}`,
    `${AccountContants.ChangePasswordConfirmationPath}`,
    `${AccountContants.MfaPasswordStepSegment}`,
    `${AccountContants.MfaInformationsStepSegment}`,
    `${AccountContants.MfaEmailStepSegment}`,
    `${AccountContants.MfaEmailCodeStepSegment}`,
    `${AccountContants.MfaPhoneStepSegment}`,
    `${AccountContants.MfaPhoneCodeStepSegment}`,
    `${AccountContants.MfaConfirmationStepSegment}`,
    `${NewsConstants.BasePagePath}`,
    `${NewsConstants.NewsDetailsPagePath}`,
    `${PersonalInfoConstants.ConsentConfirmationFormPagePath}`,
    `${PersonalInfoConstants.ConsentFormPagePath}`,
    `${PersonalInfoConstants.PersonalInformationsFormPagePath}`,
    `${PersonalInfoConstants.PersonalInformationsConfirmationPagePath}`,
    `${PersonalInfoConstants.PersonalInformationsIntroductionPagePath}`,
    this.PagesUrl.CentralizationPage,
    this.PagesUrl.CentralizationFormPage,
    this.PagesUrl.CentralizationPageIaah,
    this.PagesUrl.CentralizationFormPageIaah,
    this.PagesUrl.CentralizationPageIAGP,
    this.PagesUrl.CentralizationFormPageIAGP,
    this.PagesUrl.CentralizationPageIAPW,
    this.PagesUrl.CentralizationFormPageIAPW,
    this.PagesUrl.CentralizationPageInvestia,
    this.PagesUrl.CentralizationFormPageInvestia,
    this.PagesUrl.CentralizationConfirmationPage,
    this.PagesUrl.CentralizationConfirmationPageIaah,
    this.PagesUrl.CentralizationConfirmationPageIAGP,
    this.PagesUrl.CentralizationConfirmationPageIAPW,
    this.PagesUrl.CentralizationConfirmationPageInvestia,
  ];
}
